import React from "react";
import EducationEyelinerDipliner from "../Components/education/EducationEyelinerDipliner";
import TopBar from "../Components/common/TopBar";
import Spacer2 from "../Components/common/Spacer2";

function EducationEyelinerDiplinerPage() {
  return (
    <>
      <TopBar />
      <Spacer2 />
      <EducationEyelinerDipliner />
    </>
  );
}

export default EducationEyelinerDiplinerPage;
